import React, { useEffect, useState } from "react";
import "../../styles/Dashboard/OptimizationScore.css";

const OptimizationScore = ({
  userName = "Anupam",
  score = 85,
  campaigns = { confirmed: 1, unconfirmed: 3 },
}) => {
  const [currentScore, setCurrentScore] = useState(0);

  useEffect(() => {
    let animationFrameId;
    const duration = 2000; // Duration of the animation in milliseconds
    const startTime = performance.now();

    const animateScore = (timestamp) => {
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1); // Normalize progress to [0, 1]
      const newScore = Math.round(progress * score);
      setCurrentScore(newScore);

      if (progress < 1) {
        animationFrameId = requestAnimationFrame(animateScore);
      }
    };

    animationFrameId = requestAnimationFrame(animateScore);

    return () => cancelAnimationFrame(animationFrameId);
  }, [score]);

  return (
    <div className="optimization-card">
      <div style={{ display: "flex", justifyContent: "space-between", gap: "32px", alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <div className="user-greeting">
            <span className="wave-emoji">👋</span>
            <h2>Hi, {userName}</h2>
          </div>

          <div className="score-section">
            <p className="score-title">
              Here is your optimization score <span className="info-icon">ⓘ</span>
            </p>

            <div className="campaigns-info" style={{ marginTop: "20px" }}>
              <div className="campaign-item">
                <span className="dot unconfirmed"></span>
                <span className="fw-bold">{campaigns.unconfirmed} campaign</span>
                <span className="focus-text">focus are unconfirmed</span>
              </div>
              <div className="campaign-item">
                <span className="dot confirmed"></span>
                <span className="fw-bold">{campaigns.confirmed} campaign</span>
                <span className="focus-text">focus is confirmed</span>
              </div>
            </div>

            <button className="learn-more-btn">
              Learn how you rank and get detailed insights on how to boost your
              score
              <span className="arrow">→</span>
            </button>
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <div className="score-display">
            <div className="gauge-container">
              <div className="gauge">
                <div
                  className="gauge-fill"
                  style={{
                    transform: `rotate(${(currentScore / 100) * 180}deg)`,
                    "--score-percentage": `${currentScore}%`,
                  }}
                ></div>
                <div className="gauge-mask"></div>
              </div>
              <div className="score-value">{Math.round(currentScore)}</div>
              <div className="score-label">
                Your optimization score is
                <br />
                getting better
              </div>
              <div className="improvement">↑ 10%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptimizationScore;